import toast, { type ToastPosition } from 'react-hot-toast';

import CustomToast from '~/components/CustomToast';

type ToastProps = {
  title: string;
  message: string;
  ctaText?: string;
  onCtaClick?: () => void;
  duration?: number;
  position?: ToastPosition;
};

export class Toast {
  static getDefaultOptions(props: ToastProps) {
    return {
      duration: props.duration ?? 6000,
      position: props.position ?? 'bottom-right',
    };
  }

  static info(props: ToastProps) {
    toast.custom((t) => {
      return <CustomToast {...props} t={t} type="info" />;
    }, this.getDefaultOptions(props));
  }

  static success(props: ToastProps) {
    toast.custom((t) => {
      return <CustomToast {...props} t={t} type="success" />;
    }, this.getDefaultOptions(props));
  }

  static error(props: ToastProps) {
    toast.custom((t) => {
      return <CustomToast {...props} t={t} type="error" />;
    }, this.getDefaultOptions(props));
  }
}
